// extracted by mini-css-extract-plugin
export default {"container":"sarrafehLoading_container__e1gbc","fadeInAndOut":"sarrafehLoading_fadeInAndOut__YOC2k"};